import React, { Component } from 'react'
import { connect} from 'react-redux'
import Waypoint from 'react-waypoint'
import Heading from 'grommet/components/Heading'
import { setSectionVisibility, setParticleVisibility, setSectionProperty } from '../../actions/sections/SectionsActions'
import './Services.css'

@connect((state) => ({
  isVisible: state.sectionsReducer.services.isVisible,
  webDevelopmentVisible: state.sectionsReducer.services.webDevelopmentVisible,
  userExperienceVisible: state.sectionsReducer.services.userExperienceVisible,
  frontEndVisible: state.sectionsReducer.services.frontEndVisible,
  strategyVisible: state.sectionsReducer.services.strategyVisible
}), { setSectionVisibility, setParticleVisibility, setSectionProperty })
class Services extends Component {

  handleWaypointEnter = () => {
    const { setSectionVisibility, setParticleVisibility } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
    setSectionVisibility('services', true)
  }

  handleWaypointLeave = () => {
    const { setSectionVisibility } = this.props
    setSectionVisibility('services', false)
  }

  render() {
    const {isVisible } = this.props
    const className = `Services${isVisible ?  ' is-visible' : ''}`
    return (
      <div className={className}>
        <Waypoint scrollableAncestor={window} onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave}/>
          <div className="Services-container">
            <div className="Services-child Services-textContainer">
              <Heading tag="h2" uppercase={true} strong={true} className="Services-title">What we love doing</Heading>
            </div>
        </div>
      </div>
    )
  }
}

export default Services


// WEBPACK FOOTER //
// ./src/components/Services/index.js